import React from 'react';
import { Badge, BadgeProps } from '@/components/ui/badge';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface StatCardProps {
  testId: string;
  icon: React.ReactNode;
  count: number;
  label: string;
  countClassName?: string;
  badge?: { text: string; variant?: BadgeProps['variant'] };
}

const StatCard: React.FC<StatCardProps> = ({
  testId,
  icon,
  count,
  label,
  countClassName,
  badge,
}) => (
  <Card data-testid={testId} className="h-full">
    <CardContent className="text-center min-h-[132px] pt-6">
      {icon}
      <p className={cn('text-3xl font-semibold', countClassName)}>{count}</p>
      <p className="text-sm text-muted-foreground">{label}</p>
      {badge && (
        <Badge variant={badge.variant} className="mt-2">
          {badge.text}
        </Badge>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
